const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  SHIP_VIA: "/logisticservice/api/ship-via/",
  HUB: "/logisticservice/api/hub/",
  BROKER: "/logisticservice/api/broker/",
  REMOTE_AREA: "/logisticservice/api/remote-area/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  REMOTE_CHARGE: "/logisticservice/api/remote-charge/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  CONFIGUARTION: "/logisticservice/api/configuration/",
  LOCATION_LIST: "/logisticservice/api/location/list/",
  PERMISSION: "/permission/",
};

export default APIS;
